// import { gsap } from 'gsap'
// import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
// gsap.registerPlugin(ScrollTrigger);

import {Modal} from 'bootstrap';
import { Notyf } from 'notyf';
import 'notyf/notyf.min.css'; // for React, Vue and Svelte

// Create an instance of Notyf
const notyf = new Notyf({
  duration: 10000,
  position: {
    x: 'center',
    y: 'center',
  },

});



import { Spinner } from './load'

window.addEventListener('load', () => {
  const getAll = (query, Root = document) => Root.querySelectorAll(query);
  const TabLink = getAll('.TabLink span');
  TabLink.forEach(current => {
    if (current.getAttribute('icon') === "bi bi-list-stars") {
      current.setAttribute('class', 'fas fa-clipboard-list me-1');
    }
    if (current.getAttribute('icon') === "INCLUSIONS") {
      current.setAttribute('class', 'fas fa-check-circle me-1');
    }
    if (current.getAttribute('icon') === "PRICE & AVAILABILITY") {
      current.setAttribute('class', 'fas fa-tags me-1');
    }
    if (current.getAttribute('icon') === "IMPORTANT INFO") {
      current.setAttribute('class', 'fas fa-info me-1');
    }
    if (current.getAttribute('icon') === "PACKING LIST") {
      current.setAttribute('class', 'fas fa-list-ol me-1');
    }
  });
  // 
  // new
  const nav = document.querySelector('#menu');
  const navLinks = document.querySelectorAll('.TabLink');
  const sections = document.querySelectorAll('.secciont-tab');

  window.addEventListener('scroll', () => {
    const currentPos = window.pageYOffset;

    sections.forEach((section) => {
      if (
        currentPos >= section.offsetTop - 150 &&
        currentPos <= section.offsetTop + section.offsetHeight - 150
      ) {
        const currentSection = section.getAttribute('id');
        navLinks.forEach((link) => {
          link.classList.remove('active');
          if (link.getAttribute('href').slice(1) === currentSection) {
            link.classList.add('active');
          }
        });
      }
    });

    if (currentPos > nav.offsetTop) {
      nav.classList.add('sticky');
    } else {
      nav.classList.remove('sticky');
    }
  });
})



const form = document.querySelector('.page_form');
const loader = new Spinner({
  selector: '.loandig',
  width: 25,
  height: 25,
  text: 'Sending..',
  color: '#d7b672',
  background: '#fff'
});

if (form) {
  const url = form.getAttribute('action');
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    loader.active();
    const formData = new FormData(form);
    try {
      const response = await fetch(url, {
        method: 'POST',
        body: formData
      });
      const data = await response.json();
      if (response.ok) {
        loader.hide();
        form.reset();
        alert(data.message);
      } else {
        throw new Error(data.message || 'Sending Error');
      }
    } catch (error) {
      loader.hide();
      console.error(error)
      alert(`Error: ${error.message}`);
    }
  });
}
// book
window.addEventListener('load', function () {
  // Fetch all the forms we want to apply custom Bootstrap validation styles to
  const forms = document.getElementsByClassName('needs-validation');

  // var myModal = new Modal(document.getElementById('inquire'))
  const myModal = new bootstrap.Modal('#inquire', {
    keyboard: false
  })
  // Loop over them and prevent submission
  // let recaptcha = grecaptcha.getResponse();
  let validation = Array.prototype.filter.call(forms, function (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      loader.active();
      let recaptcha = grecaptcha.getResponse();
      if (form.checkValidity() === false || recaptcha.length == 0) {
        form.classList.add('was-validated');
        loader.hide();
        return event.stopPropagation();
      }
      if (form.checkValidity() && recaptcha.length > 0) {
        const DataForm = new FormData(form);
        const url = form.getAttribute('action');
        fetch(url, { method: 'POST', body: DataForm })
          .then(res => res.json())
          .then(data => {
            let { message, status } = data;
            if(status === 200) {
              loader.hide();
              myModal.hide();
              notyf.success({
                message:message,
                icon: '<i class="bi bi-check2"></i>'
              })
            }else{
              loader.hide();
            }
          })
      }
    });
  });
  // ////////////////////////////////////// form subcribe
  const subcribe = document.querySelector('.fr-subscribe');
  //  Api Get  geolocation
  let geo = '';

  fetch('https://ipapi.co/json/')
    .then(response => response.json())
    .then(data => {
      geo = data.country;
    })
  subcribe.addEventListener('submit', (e) => {
    e.preventDefault();

    const db = new FormData();
    db.append('name', subcribe.name.value);
    db.append('email', subcribe.email.value);
    db.append('pais', geo);
    const url = '/wp-content/themes/orangeblog/db/db.php'
    fetch(url, { method: 'POST', body: db })
      .then(res => res.json())
      .then(data => {
        if (data.status) {
          notyf.success({
            message: 'thanks for subscribing',
            icon: '<i class="fa fa-check"></i>'
          })
          subcribe.reset();
        }
        if (!data.status) {
          alert('is already subscribed');
          subcribe.reset()
        }
      })
  })
});